import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { Component, Input, Output, EventEmitter, ViewEncapsulation, ElementRef, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ENV } from 'config';
import { ManageInventoryService } from './../shared/providers/manage-inventory.service';
import { KEY_CONFIG } from './../../../../lib/ng2-sapmp/src/config/key-config';

declare var ENV_VAR: any;

@Component({
    selector : 'app-device-wipe',
    templateUrl : './device-wipe.component.html',
    styleUrls : ['./device-wipe.component.scss'],
    providers: [ManageInventoryService],
    encapsulation: ViewEncapsulation.None
})

export class DeviceWipeComponent implements OnInit {
    public jsonRes: any;
    public device: any;
    public focusAbleElements: any;

    @Input() fan: any;
    @Input() ban: any;
    @Input() ctn: any;
    @Input() triggerElement: any;
    @Output() modalOutput: EventEmitter<boolean>;
    @Output() responseVal: EventEmitter<any>;

    deenrolled: any = 'withoutUnEnroll';

    constructor(private util: UtilityService, private el: ElementRef,
        private manageInventoryService: ManageInventoryService,
        private router: Router, private pageloaderService: PageLoaderService) {
        this.modalOutput = new EventEmitter<boolean>();
        this.responseVal = new EventEmitter<any>();
        manageInventoryService.fetchJSON(this.util.getEnvConfig().contentUrl.manageInventory.deviceLockWipeDetailsUrl).subscribe(resObj => {
        this.jsonRes = resObj;
        this.device = {
            deenrolled : '',
            wiped : ''
        };
    });
    }

    ngOnInit() {
        document.body.classList.add('modal-open');
    }

    ok() {
      const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
      const isDisabled = impersonator && impersonator.id ? true : false;
      if (isDisabled) {
        (<HTMLInputElement>document.getElementById('device-wipe-btn')).disabled = true;
      } else {
        this.pageloaderService.setPageLoaderStatus(false);
        const currentCtnDetails = JSON.parse(sessionStorage.getItem('currentCtnDetails'));
        if (this.device.deenrolled === '') {
            this.device.deenrolled = false;
        }
         this.device.wiped = true;
         if (this.device.deenrolled === true) {
            this.deenrolled = 'withUnEnroll';
         } else {
            this.deenrolled = 'withoutUnEnroll';
         }
         this.manageInventoryService.getDeviceWipeStatus(this.deenrolled, this.device.wiped,
            currentCtnDetails.emmTenantId, currentCtnDetails.emmDeviceId ).
        subscribe(respobj => {
            if (respobj.success) {
                this.pageloaderService.setPageLoaderStatus(true);
                this.responseVal.emit(this.device);
            }else {
                this.pageloaderService.setPageLoaderStatus(true);
                this.responseVal.emit(false);
            }
         }, error => {
        this.handleError(error);
    });
        document.body.classList.remove('modal-open');
      }
    }

    cancelModal(value) {
       document.body.classList.remove('modal-open');
       this.modalOutput.emit(value);
       if (this.triggerElement) {
        this.triggerElement.focus();
      }
    }

    handleError(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    throw error;
   }

   loadFocusTelements() {
    if (!this.focusAbleElements) {
      const focusAbleEls = this.util.getFocusableElements(this.el);
      this.focusAbleElements = Array.prototype.slice.call(focusAbleEls);
      document.getElementById('modalHeading').focus();
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.dimissModal(false);
      return;
    }
    this.util.handleKeyPress(event, this.focusAbleElements);
  }
  dimissModal(value, event?) {
    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      document.body.classList.remove('modal-open');
      this.modalOutput.emit(value);
      this.focusAbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
    }

}
}
